import React from "react";
import { useTranslation } from "react-i18next";
import CommonDialog from "../../../../../common/components/dialog/CommonDialog";
import Button from "../../../../../common/ekedc-components/button/Button";
import electricityGif from "../../../../../assets/gifs/electricity.gif";
import checkmarkGif from "../../../../../assets/gifs/checkmark.gif";
import styles from "./energy-profile-success-modal.module.scss";

interface EnergyProfileSuccessModalProps {
	serviceType: string;
	accountOrMeterNumber: string;
	onEnergyProfilePage: () => void;
	onBackToHome: () => void;
}

const ADDRESS = "N/A";

const EnergyProfileSuccessModal: React.FC<EnergyProfileSuccessModalProps> = ({
	serviceType,
	accountOrMeterNumber,
	onEnergyProfilePage,
	onBackToHome,
}) => {
	const { t } = useTranslation();
	return (
		<CommonDialog onCloseDialog={onBackToHome} noPadding>
			<div className={styles.content}>
				<div className={styles.animation}>
					<img className={styles.gif} src={electricityGif} alt="" aria-hidden="true" />
					<img className={`${styles.gif} ${styles.gifOverlay}`} src={checkmarkGif} alt={t("account.web.successAlt")} />
				</div>

				<h2 className={styles.title}>{t("energyManagement.energyProfile.youreAllSet")}</h2>
				<p className={styles.subtitle}>{t("account.web.energyProfileReadySubtitle")}</p>

				<div className={styles.detailsCard}>
					<div className={styles.detailRow}>
						<span className={styles.detailLabel}>{t("common.labels.serviceType")}</span>
						<span className={styles.detailValue}>{serviceType}</span>
					</div>
					<div className={styles.detailRow}>
						<span className={styles.detailLabel}>{t("energyManagement.energyProfile.accountMeterNumber")}</span>
						<span className={styles.detailValue}>{accountOrMeterNumber}</span>
					</div>
					<div className={styles.detailRow}>
						<span className={styles.detailLabel}>{t("common.labels.address")}</span>
						<span className={styles.detailValue}>{ADDRESS}</span>
					</div>
				</div>

				<div className={styles.buttonsRow}>
					<Button text={t("energyManagement.energyProfile.energyProfilePageButton")} variant="secondary" onClick={onEnergyProfilePage} className={styles.button} />
					<Button text={t("common.pages.backToHome")} onClick={onBackToHome} className={styles.button} />
				</div>
			</div>
		</CommonDialog>
	);
};

export default EnergyProfileSuccessModal;
